import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import {isEmpty, result} from 'lodash';
import NumberFormat from 'react-number-format';
import {Line, Bar} from 'react-chartjs-2';

import {GET_BLACKOUT_DAY_LIST} from "../../actions/ActionTypes";
import {getUser, getPermission} from "../../utils/TokenManager";
import {PTO_REQUEST} from "../common/Constants";
import {agencyTrendData, lineChartOptions} from '../common/LineGraph';
import loadingGIF from "../../public/assets/images/loading.gif";
import ErrorMsg from "../common/ErrorMsg";
import {UNLIMITED_PTO} from "../pto/Constants";
import ClockOutModal from "./ClockOutModal";
import AddAchievementModal from "./AddAchievementModal";
import StaffDataList from "./StaffDataList";
import AgencyRevenueService from "../../services/AgencyRevenueService";
import LoadingModal from "../common/LoadingModal";
import PTOModal from "../pto/PTORequestModal";
import StaffCalendar from "../pto/StaffCalendar";
import SickLeaveService from "../../services/SickLeaveServices";


const departmentScoreData = {
    labels: ['Commercial Lines', 'Financial Services', 'Personal Lines', 'Commercial Lines'],
    datasets: [
        {
            label: 'Department Wise Score',
            backgroundColor: 'rgba(85,119,191,0.7)',
            borderColor: 'rgba(85,119,191,0.7)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(85,119,191,1)',
            hoverBorderColor: 'rgba(85,119,191,1)',
            data: []
        }
    ]
};
const barChartOPtions = {
    maintainAspectRatio: true,
    scales: {
        xAxes: [{
            barThickness : 25,
        }]
    },
    legend: {
        display: false
    },
    plugins: {
        datalabels: {
            display: false
        }
    }
}

export default class Home extends Component {

    state = {
        staffKPIList: [],
        performanceRangeList: [],
        periodDateRange: '',
        periodStartDate: '',
        periodEndDate: '',
        personalEvaluationScore: 0,
        shouldHaveEvaluationScore: 0,
        performanceIncome: 0,
        availPerformanceIncome: 0,
        totalMaxScore: 0,
        commission_name: '',
        revenueSharingIncome: 0,
        openClockOutModal: false,
        agencyRevenueAvailability: false,
        revenueSharingAvailability: false,
        plProfileId: 0,
        timeClock: false,
        agencyScore: 0,
        departmentScore: {},
        departmentList: [],
        nameDesc: {},
        openAddAchievementModal: false,
        selectedKPI: {},
        openAchievementListModal: false,
        goal: true,
        score: true,
        showDeptScoreLoading: false,
        totalLocation: 1,
        combinedDataOption: 0,
        sortByPercentageAchieved: false,
        openPTO: false,
        activeSection: 0,
        selectedPTORequest: {
            requestObj: {},
            clear: true
        },
        showPTOInfo: false,
        showSharedCalendar: false,
        sickleaveinfoforuser:{}
        
    }

    componentDidMount = () => {
        this.getInitialState();
        this.getLocationCount();
        this.getPTOInfo();
        this.getUserSickLeaveInfo();
        this.getHolidayList();
        this.getBlackoutDayList();
        this.getBirthdayList();
        this.getSickLeaveSetting();
    };


    getInitialState = async () => {
        // Get Staff KPI List
        this.setState({isLoading: true});
        try {
            let result = await this.props.getStaffKPI();

            if (result) {
                if(!(isEmpty(this.props.staffDashboard.staffKPIList))) {
                    let {
                        period_date_range, period_start_date, period_end_date, 
                        personal_evaluation_score, should_have_evaluation_score, 
                        performance_income, available_performance_income, total_max_score, 
                        commission_name, commission_revenue_income, agency_revenue_available, 
                        revenue_sharing_available, pl_profile_id, time_clock,
                        pto_info_available, goal, score, commission_report_available,
                        use_shared_calendar,
                    } = this.props.staffDashboard.staffKPIList;

                    let staffKPIList = this.props.staffDashboard.staffKPIList.assigned_kpi_list.map(kpi => ({...kpi}));

                    let performanceRangeList = this.props.staffDashboard.staffKPIList.performance_range_list.map(range => ({...range}));

                    this.setState({
                        staffKPIList,
                        performanceRangeList, 
                        periodDateRange: period_date_range,
                        periodStartDate: period_start_date,
                        periodEndDate: period_end_date,
                        personalEvaluationScore: personal_evaluation_score, 
                        shouldHaveEvaluationScore: should_have_evaluation_score,
                        performanceIncome: performance_income,
                        availPerformanceIncome: available_performance_income,
                        totalMaxScore: total_max_score,
                        commission_name: commission_name,
                        revenueSharingIncome: commission_revenue_income,
                        agencyRevenueAvailability: agency_revenue_available,
                        revenueSharingAvailability: revenue_sharing_available,
                        commissionReportAvailability: commission_report_available,
                        showPTOInfo: pto_info_available,
                        showSharedCalendar: use_shared_calendar,
                        plProfileId: pl_profile_id,
                        timeClock: time_clock,
                        goal, score
                    }, () => {this.getOtherDetails()});
                }
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        // Get clock-in status
        try {
            await this.props.getClockInStatus();
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        this.setState({isLoading: false});
    };

    getOtherDetails = () => {
        const {
            score, agencyRevenueAvailability, showPTOInfo, showSharedCalendar
        } = this.state;
        if (score) {
            this.getDepartmentsAndScores();
        }

        if (agencyRevenueAvailability) {
            this.getLineGraphData();
        }

        if (showPTOInfo || showSharedCalendar) {
            this.getTimeOffList();
        }
    };

    getLocationCount = async () => {
        try {
            let result = await this.props.getLocationCount();
            if (result) {
                let totalLocation = result.count;
                this.setState({totalLocation});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
    }

    getHolidayList = async () => {
        try {
            let locationId = getUser().agency_location;
            const year = new Date().getFullYear();
            const result = await this.props.ptoSetting(
                locationId, {}, year, "GET"
            );
            if (result) {
                const {settings} = this.props.pto;
                await this.props.getAssignedHolidayList(settings.id);
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    getBlackoutDayList = async () => {
        try {
            await this.props.blackoutDayAction({
                type: GET_BLACKOUT_DAY_LIST,
                locationId: getUser().agency_location
            });
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    getTimeOffList = async () => {
        try {
            await this.props.getTimeOffList(getUser().id);
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }
    
    getBirthdayList = async () => {
        try {
            const year = new Date().getFullYear();
            await this.props.getBirthdayList(year);
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    getSickLeaveSetting = async() =>{
        const year = new Date().getFullYear();
        const resultSL = await SickLeaveService.getSickLeaveSetting(getUser().agency_location,year)
        this.setState({is_sick_leave_allowed:resultSL.data['is_sick_leave_allowed']})
    }

    openPTOModal = () => {
        this.setState({
            openPTO: true, 
            selectedPTORequest: {requestObj: {}, clear: true}
        });
    };

    togglePTOModal = () => {
        this.setState(
            (prevState) => ({openPTO: !prevState.openPTO})
        );
    };

    getPTOInfo = async () => {
        try {
            await this.props.getStaffPTOInfo();
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }
    
    getSickLeaveInfo = async () => {
        try {
            await this.props.getStaffSickLeaveInfo();
            console.log(this.props)
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    refreshPTOInfos = () => {
        this.getPTOInfo();
        this.getTimeOffList();
    }

    getDepartmentsAndScores = async () => {
        try {
            let {combinedDataOption} = this.state;
            const departments = await this.props.getDepartmentList(combinedDataOption);
            this.setState(
                {departmentList:  [...departments]}, 
                () => {this.getSetScore()}
            );
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    }

    getLineGraphData = async () => {
        if (this.state.plProfileId > 0) {
            try {
                const result = await AgencyRevenueService.lineGraph(this.state.plProfileId);

                if (200 === result.status) {
                    if (result.data.pl_profile) {
                        let lineGraph = result.data.pl_profile;
                        agencyTrendData.labels = lineGraph.month_list;
                        agencyTrendData.datasets[0].data = lineGraph.goals;
                        agencyTrendData.datasets[1].data = lineGraph.revenue_actual;
                        agencyTrendData.datasets[2].data = lineGraph.last_year_revenues;
                    }
                } 
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
            }
        }
    }

    // get agency score and department wise score
    getSetScore = async () => {
        this.setState({showDeptScoreLoading: true});
        try {
            let {combinedDataOption} = this.state;
            const result = await this.props.getScores(combinedDataOption);
            if (result) {
                let agencyScore = result.agency_avg_score;
                let departmentScore = result.department_score;
                let labels = [], scores = [], nameDesc = {};
                // set label and data in agency score
                this.state.departmentList.map(department => {
                    let shortName = this.shortName(department);
                    labels.push(shortName);
                    // Object containing full name for each short name
                    nameDesc[shortName] = department;
                    this.setState({nameDesc});

                    if (department in departmentScore) {
                        scores.push(departmentScore[department]);
                    } else {
                        scores.push(0);
                    }
                });
                departmentScoreData.labels = labels;
                departmentScoreData.datasets[0].data = scores;
                this.setState({agencyScore, departmentScore});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }
        this.setState({showDeptScoreLoading: false});
    }

    shortName = (name) => {
        let matches = name.match(/\b(\w)/g);
        let acronym = matches.join('');
        return acronym;
    }

    postClockIn = async () => {
        // CLicked on clock-in
        try {
            await this.props.postClockIn();
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        return false;
    };

    toggleClockOutModal = () => {
        this.setState((prevState) => ({openClockOutModal: !prevState.openClockOutModal}));
    };

    openClockOutModal = () => {
        this.setState({openClockOutModal: true});
    }

    toggleAddAchievementModal = () => {
        this.setState((prevState) => ({
            openAddAchievementModal: !prevState.openAddAchievementModal
        }));
    };

    openAddAchievementModal = (kpi) => {
        this.setState({openAddAchievementModal: true, selectedKPI: kpi});
    };

    toggleAchievementListModal = () => {
        this.setState((prevState) => ({
            openAchievementListModal: !prevState.openAchievementListModal
        }));
    };

    openAchievementListModal = (kpi) => {
        this.setState({openAchievementListModal: true, selectedKPI: kpi});
    };

    // Update scores after adding achievement
    updateAchievement = (achievementData, requiredHeadingData, wantToClose, canToggle) => {
        let {staffKPIList, personalEvaluationScore, agencyScore} = this.state;
        let newKPIList = staffKPIList.map((kpi, index) => {
            if (kpi.kpi_list_id === achievementData.kpi_list) {
                let dupKpi = {...kpi};
                let actualAchieved = kpi.actual_achieved;
                
                // check kpi formula type and calculate acore accordingly
                if (kpi.kpi_property_formula === "Add") {
                    if (isNaN(requiredHeadingData)) {
                        actualAchieved += 0;
                    } else {
                        actualAchieved += parseFloat(requiredHeadingData);
                    }
                } else {
                    actualAchieved ++;
                }
                
                let evaluationScore = kpi.evaluation_score;
                if (kpi.period_meet_goal > 0 && kpi.period_meet_goal >= actualAchieved) {
                    evaluationScore = ((kpi.max_score / kpi.period_meet_goal) * actualAchieved);
                } else {
                    evaluationScore = kpi.max_score;
                }
                let changeInScore = evaluationScore - kpi.evaluation_score;
                let tempPerEvalScore = personalEvaluationScore + changeInScore;
                let tempAgencyScore = agencyScore + changeInScore;
                this.setState({
                    personalEvaluationScore: tempPerEvalScore,
                    agencyScore: tempAgencyScore
                });
                dupKpi['actual_achieved'] = actualAchieved;
                dupKpi['evaluation_score'] = evaluationScore;
                return dupKpi;
            }
            return kpi;
        });
        this.setState({staffKPIList: newKPIList});
        if (wantToClose && canToggle) {
            this.toggleAddAchievementModal();
            this.sortKPI();
        }
    };

    combinedDataOptionChange = (e) => {
        const selectedOption = parseInt(e.target.value);
        this.setState(
            {combinedDataOption: selectedOption}, 
            () => {
                this.getDepartmentsAndScores();
            }
        )
    }

    // Compare KPI for sorting
    compareKPIbyName = (a, b) => {
        if (a.kpi_name.toUpperCase() < b.kpi_name.toUpperCase()) {
            return -1;
        }
        if (a.kpi_name.toUpperCase() > b.kpi_name.toUpperCase()) {
            return 1;
        }
        return 0;
    };

    compareKPIbyPercentageAchieved = (a, b) => {
        let percentageAchievedForA = 100, percentageAchievedForB = 100;
        if (a.period_meet_goal) {
            percentageAchievedForA = a.actual_achieved / a.period_meet_goal * 100;
        }
        if (b.period_meet_goal) {
            percentageAchievedForB = b.actual_achieved / b.period_meet_goal * 100;
        }
        if (percentageAchievedForA < percentageAchievedForB) {
            return -1;
        }
        if (percentageAchievedForA > percentageAchievedForB) {
            return 1;
        }
        return 0;
    };

    handleSortingChange = () => {
        this.setState(prevState => (
            {sortByPercentageAchieved: !prevState.sortByPercentageAchieved}
        ), () => this.sortKPI());
    }

    sortKPI = () => {
        const {staffKPIList, sortByPercentageAchieved} = this.state;
        let kpiList = staffKPIList.map(kpi => ({...kpi}));
        if (sortByPercentageAchieved) {
            kpiList.sort(this.compareKPIbyPercentageAchieved);
        } else {
            kpiList.sort(this.compareKPIbyName);
        }
        this.setState({staffKPIList: kpiList});
    }

    showTimeOffRequest = (request, clear=false) => {
        if(!clear) {
            this.setState({
                openPTO: true, 
                selectedPTORequest: {requestObj: {...request}, clear}
            });
        }
    }

    getScrollableSection = () => {
        const {
            showDeptScoreLoading, totalLocation, combinedDataOption,
            score, agencyRevenueAvailability, plProfileId, nameDesc, 
            staffKPIList, showPTOInfo, showSharedCalendar
        } = this.state;
        let nameDiscLabel = [];
        for (let key in nameDesc) {
            nameDiscLabel.push(
                <label key={key} className="float-left pr-3 mb-1">
                    {key}: {nameDesc[key]}
                </label>
            )
        }
        let sectionList = [];
        let isProfileEnabled = staffKPIList.length > 0;
        let calendarHeight = "100%", deptScoreHeight=160;
        if (isProfileEnabled && score ) {
            calendarHeight = "330px";
        } else if (!isProfileEnabled && (showPTOInfo || showSharedCalendar)) {
            calendarHeight = "85vh";
            deptScoreHeight = 100;
        }
        if ( (isProfileEnabled && showPTOInfo) || (!isProfileEnabled && showSharedCalendar)) {
            sectionList.push(
                <div className="card-body">
                    <StaffCalendar {...this.props} height={calendarHeight}
                        showTimeOffRequest={this.showTimeOffRequest}
                        refreshPTOInfos={this.refreshPTOInfos}
                        selectedUser={getUser().id}
                    />
                </div>
            )
        }

        if (score) {
            sectionList.push(
                <React.Fragment>
                    <div className="card-header text-center p-2 bg-f5">
                        <label className="mb-0">Department Scores </label> &nbsp;
                        {totalLocation > 1 && <React.Fragment>
                            <select name="locationToggle"
                                value={combinedDataOption}
                                onChange={this.combinedDataOptionChange}
                            >
                                <option value={0}>Your Location</option>
                                <option value={1}>All Locations</option>
                            </select>
                            &nbsp;
                            {showDeptScoreLoading &&
                                <img src={loadingGIF} alt="Loading" 
                                    width="24" height="24" 
                                />
                            }
                        </React.Fragment>}
                    </div>
                    <div className="card-body position-relative">
                        <Bar
                            data={departmentScoreData}
                            options={barChartOPtions}
                            height={deptScoreHeight}
                        />
                        <div className="overflow-hidden text-info">
                            {nameDiscLabel}
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        if (agencyRevenueAvailability) {
            sectionList.push(
                <React.Fragment>
                    <div className="card-header text-center p-2 bg-f5">
                        <label className="mb-0">Monthly Revenue Goals</label>
                    </div>
                    <div className="card-body position-relative">
                        {plProfileId > 0 ?
                            <Line data={agencyTrendData} height={180} 
                                options={lineChartOptions} />
                            : <span className="text-danger">Data not available.</span>
                        }
                    </div>
                </React.Fragment>
            )
        }

        return sectionList;
    }

    getNextPTOForm = () => {
        let {activeSection} = this.state;
        activeSection += 1;
        if (activeSection >= this.getScrollableSection().length) {
            activeSection = 0;
        }
        this.setState({activeSection: activeSection});
    }

    getPrevPTOForm = () => {
        let {activeSection} = this.state;
        activeSection -= 1;
        if (activeSection < 0) {
            activeSection = this.getScrollableSection().length - 1;
        }
        this.setState({activeSection: activeSection});
    }

    getUserSickLeaveInfo = async () => {
        this.setState({isLoading: true});
        
        try {
          const resultSL = await SickLeaveService.getStaffSickLeaveInfo()
          console.log("user info for sick leave"+resultSL.data['id'])
            this.setState({sickleaveinfoforuser:resultSL.data})
        } catch(error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false});
    }

    renderTable = () => {
       
        const {staffKPIList, goal, score, sortByPercentageAchieved} = this.state;
        let KPIList = staffKPIList.map((kpi, index) =>         
            <tr key={index} className="table-border-2">
                <td className="align-middle p-t-10 p-b-10 text-center"
                    title="Open Achievements"
                >
                    <a href="javascript:" onClick={() => this.openAchievementListModal(kpi)}> 
                        <i className="fa fa-search-plus text-primary font-16"></i>
                    </a>
                </td>
                <td className="align-middle w-30 p-t-10 p-b-10">
                    {
                        kpi.show_on_dashboard ? 
                            <a href="javascript:" onClick={
                                    () => this.openAddAchievementModal(kpi)} 
                                className="kpi-anchor text-primary"
                            >
                                {kpi.kpi_name}
                            </a> 
                        : 
                            kpi.kpi_name
                    }
                </td>
                {goal ? <React.Fragment>
                    <td className="text-center align-middle p-t-10 p-b-10">
                    {kpi.data_type === "Currency" ? 
                        <NumberFormat value={kpi.period_meet_goal} displayType={'text'} 
                            thousandSeparator={true} decimalScale={2} prefix={'$'} 
                        />
                        : kpi.data_type === "Percentage" ? 
                            <NumberFormat value={kpi.period_meet_goal} displayType={'text'} 
                                thousandSeparator={true} decimalScale={2} suffix={' %'} 
                            />
                        : <NumberFormat value={kpi.period_meet_goal} displayType={'text'} 
                            thousandSeparator={true} decimalScale={2} 
                        />
                    }
                    </td>
                    <td className="text-center align-middle p-t-10 p-b-10">
                    {kpi.data_type === "Currency" ? 
                        <NumberFormat value={kpi.should_have_as_of_today} 
                            displayType={'text'} thousandSeparator={true} 
                            decimalScale={2} prefix={'$'} 
                        />
                        : kpi.data_type === "Percentage" ? 
                        <NumberFormat value={kpi.should_have_as_of_today} 
                            displayType={'text'} thousandSeparator={true} 
                            decimalScale={2} suffix={' %'} 
                        />
                        : <NumberFormat value={kpi.should_have_as_of_today} 
                            displayType={'text'} thousandSeparator={true} 
                            decimalScale={2} 
                        />
                    }
                    </td></React.Fragment>
                    : null
                }
                <td className="text-center align-middle p-t-10 p-b-10">
                {kpi.data_type === "Currency" ? 
                    <NumberFormat value={kpi.actual_achieved} displayType={'text'} 
                        thousandSeparator={true} decimalScale={2} prefix={'$'} />
                    : kpi.data_type === "Percentage" ? 
                    <NumberFormat value={kpi.actual_achieved} displayType={'text'} 
                        thousandSeparator={true} decimalScale={2} suffix={' %'} />
                    : <NumberFormat value={kpi.actual_achieved} displayType={'text'} 
                        thousandSeparator={true} decimalScale={2} />
                }
                </td>
                {score ? 
                    <React.Fragment>
                        <td className="text-center align-middle p-t-10 p-b-10">
                            {kpi.max_score}
                        </td>
                        <td className="text-center align-middle p-t-10 p-b-10">
                            <NumberFormat value={kpi.evaluation_score} 
                                displayType={'text'} thousandSeparator={true} 
                                decimalScale={2} 
                            />
                        </td>
                    </React.Fragment>
                    : null
                }
            </tr>
        );
        return (
            <div className="section-border bg-white h-100">
                <Table striped bordered size="sm" className="mb-0">
                    <thead className="dashboard-bg-4 border">
                        <tr>
                            <th className="border-top-0 pb-1 font-weight-bold 
                                text-center" colSpan="2">
                            </th>
                            {goal && 
                                <th className="border-top-0 pb-1 
                                    font-weight-bold text-center" colSpan="2"
                                >Goals For Current Report Period</th>
                            }
                            <th className="border-top-0 pb-1 font-weight-bold 
                                text-center" colSpan={1 + (score ? 2 : 0)}
                            >Evaluation Score For Current Report Period</th>
                        </tr>
                    </thead>
                    <thead className="dashboard-bg-5">
                        <tr>
                            <th className="border-top-0 pb-1 font-weight-bold 
                                text-center" colSpan="2"
                            >
                                KPI <br/>
                                <label className="form-check-label position-relative">
                                    <input className="form-check-input my-0" 
                                        type="checkbox"
                                        checked={sortByPercentageAchieved}
                                        value={sortByPercentageAchieved}
                                        onChange={this.handleSortingChange}
                                    />
                                    &nbsp; Sort by `% achieved`
                                </label>
                            </th>
                            {goal &&
                                <React.Fragment>
                                    <th className="border-top-0 pb-1 
                                            font-weight-bold text-center"
                                    >Period Meet Goal</th>
                                    <th className="border-top-0 pb-1 
                                            font-weight-bold text-center"
                                    >Should Have As Of Today</th>
                                </React.Fragment>
                            }
                            <th className="border-top-0 pb-1 font-weight-bold 
                                            text-center"
                            >Actual Achieved</th>
                            {score && 
                                <React.Fragment>
                                    <th className="border-top-0 pb-1 font-weight-bold text-center">
                                        Maximum Score
                                    </th>
                                    <th className="border-top-0 pb-1 font-weight-bold text-center">
                                        Evaluation Score
                                    </th>
                                </React.Fragment>
                            }
                        </tr>
                    </thead>
                        <tr></tr>
                    <tbody>
                        {KPIList}
                    </tbody>
                </Table>
            </div>
        )
    }

    renderScrollableSection = () => {
        const {
            activeSection, showPTOInfo, showSharedCalendar, staffKPIList
        } = this.state;
        let cardHeight = "100%";
        let isProfileEnabled = staffKPIList.length > 0;
        if (showPTOInfo || showSharedCalendar) {
            if (isProfileEnabled) {
                cardHeight = "378px";
            } else if (!isProfileEnabled) {
                cardHeight = "91vh";
            }
        } else {
            cardHeight = "378px";
        }
        let noOfScrollableSection = this.getScrollableSection().length;
        return (
            <div className="card section-border position-relative mb-0"
                style={{height: cardHeight}}
            >
                {noOfScrollableSection > 1 &&
                    <span className="fa fa-angle-left pto-arrow-left"
                        onClick={this.getPrevPTOForm}
                    ></span>
                }
                {this.getScrollableSection()[activeSection]}
                {noOfScrollableSection > 1 &&
                    <span className="fa fa-angle-right pto-arrow-right"
                        onClick={this.getNextPTOForm}
                    ></span>
                }
            </div>
        )
    }

    renderIncomes = () => {
        const {
            availPerformanceIncome, revenueSharingAvailability, commission_name,
            revenueSharingIncome, performanceRangeList, personalEvaluationScore
        } = this.state;

        let earnedIncome = 0;

        performanceRangeList.map(range => {
            if (parseInt(personalEvaluationScore) >= range.low_range && 
                parseInt(personalEvaluationScore) <= range.high_range
            ) {
                earnedIncome = availPerformanceIncome * range.percent_performance_income / 100;
            }
        });

        return (
            <div className="d-flex justify-content-between">
                <div className="card section-border w-48 mb-3">
                    <div className="card-header text-center mb-0 py-2 bg-f5">
                        <label className="mb-0">KPI Performance Income</label>
                    </div>
                    <div className="card-body text-center font-weight-bold 
                        d-flex align-items-center p-0"
                    >
                        <div className="w-50 border-right h-100 text-center"
                            title="Total Available for the Period"
                        >
                            <small className="mb-0">Total Available</small>
                            <br/>
                            <NumberFormat value={this.props.staffDashboard.staffKPIList.new_compensation_profile ? this.props.staffDashboard.staffKPIList.total_earned : availPerformanceIncome} 
                                displayType={'text'} thousandSeparator={true} 
                                decimalScale={2} prefix={'$ '} 
                                className="font-weight-bold font-20 p-1"
                                style={{color: "rgba(85,119,191,0.8)"}}
                            />
                        </div>
                        <div className="w-50 h-100 text-center"
                            title={`Total Earned for the Period`}
                        >
                            <small className="mb-0">Total Earned</small>
                            <br/>
                            <NumberFormat value={this.props.staffDashboard.staffKPIList.new_compensation_profile ? this.props.staffDashboard.staffKPIList.total_owed : earnedIncome} 
                                displayType={'text'} thousandSeparator={true} 
                                decimalScale={2} prefix={'$ '} 
                                className="text-success font-weight-bold font-20 p-1"
                            />
                        </div>
                    </div>
                </div>
                {revenueSharingAvailability &&
                    <div className="card section-border w-48 mb-3">
                        <div className="card-header text-center mb-0 py-2 bg-f5">
                            <label className="mb-0">{commission_name} Income</label>
                        </div>
                        <div className="card-body text-center font-weight-bold p-2">
                            <NumberFormat value={revenueSharingIncome} 
                                displayType={'text'} 
                                thousandSeparator={true} 
                                decimalScale={2} prefix={'$ '} 
                                className="text-success font-weight-bold font-20 p-1"
                            />
                        </div>
                    </div>
                }   
            </div>
        )
    }

    auth = {
		user: getUser(),
        permission: getPermission()[PTO_REQUEST]
	}

    render = () => {
        let {
            periodDateRange, periodStartDate, personalEvaluationScore, 
            shouldHaveEvaluationScore, openClockOutModal, timeClock, 
            agencyScore, openAddAchievementModal, selectedKPI, score,
            openAchievementListModal, openPTO, selectedPTORequest, 
            showPTOInfo, showSharedCalendar, staffKPIList
        } = this.state;
        let status = true;
        let isProfileEnabled = staffKPIList.length > 0;

        const {staffPTOInfo} = this.props.pto;

        if(!(isEmpty(this.props.staffDashboard.clockInStatus))) {
            let {clockInStatus} = this.props.staffDashboard;
            status = clockInStatus.status;
        }

        return (
            <section className={`container-fluid ${!this.props.isStaff && "body-main-container"}`}
            >
                <div className="card card-section">
                    <div className="card-header text-white py-5px">
                        <div className="row">
                            <div className="col-9">
                                <label className="py-1 mb-0">{periodDateRange}</label>
                            </div>
                            <div className="col-3">
                                {timeClock ? status ? 
                                    <button className="btn btn-sm btn-success font-14 
                                        font-wight-bold float-right" onClick={this.postClockIn}
                                    >Clock In</button>
                                    :
                                    <button className="btn btn-sm btn-danger font-14 
                                        font-wight-bold float-right" onClick={this.openClockOutModal}
                                    >Clock Out</button>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-md-7`}>
                            {(score && isProfileEnabled) ? <div className="d-flex justify-content-between">
                                <div className="card section-border mb-3" style={{minWidth: '30%'}}>
                                    <div className="card-header text-white text-center mb-0 p-2 bg-primary">
                                        <label className="mb-0">
                                            Should Have Evaluation Score
                                        </label>
                                    </div>
                                    <div className="card-body text-center font-weight-bold p-2">
                                        <NumberFormat value={shouldHaveEvaluationScore} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} fixedDecimalScale={true} 
                                            className="font-20 text-primary" 
                                        />
                                    </div>
                                </div>
                                <div className="card section-border mb-3" style={{minWidth: '30%'}}>
                                    <div className="card-header text-white text-center p-2 compensation-bg">
                                        <label className="mb-0">
                                            Personal Evaluation score
                                        </label>
                                    </div>
                                    <div className="card-body text-center font-weight-bold p-2">
                                        <NumberFormat value={personalEvaluationScore} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} fixedDecimalScale={true} 
                                            className="font-20 text-compensation" 
                                        />
                                    </div>
                                </div>
                                <div className="card section-border mb-3" style={{minWidth: '30%'}}>
                                    <div className="card-header text-white text-center p-2 bg-score">
                                        <label className="mb-0">
                                            Agency Evaluation score
                                        </label>
                                    </div>
                                    <div className="card-body text-center font-weight-bold p-2">
                                        <NumberFormat value={agencyScore} displayType={'text'} 
                                            thousandSeparator={true} decimalScale={2} 
                                            fixedDecimalScale={true} 
                                            className="font-20 text-score" 
                                        />
                                    </div>
                                </div>
                            </div>
                            : isProfileEnabled &&
                                this.renderTable()
                            }
                        </div>
                        <div className={`${
                                !isProfileEnabled && (showPTOInfo || showSharedCalendar) 
                                    ? 'col-12' : 'pl-md-0 col-md-5'
                            }`}
                        >
                            
                            {(isProfileEnabled && showPTOInfo ) || (!isProfileEnabled && showSharedCalendar) ?
                            <div className="card mb-3 section-border">
                                <div className="d-flex justify-content-between align-items-center p-2">
                                    {staffPTOInfo.total_pto_accrued >= UNLIMITED_PTO ? null :
                                        <div className="text-center">
                                            <span className="font-weight-bold font-20 text-info">
                                                {staffPTOInfo.total_pto_accrued} {
                                                    staffPTOInfo.is_pto_in_hours ? "hour" : "day"
                                                }{staffPTOInfo.total_pto_accrued > 1 ? "s" : ""}
                                            </span>
                                            <p className="mb-0 mt-2">
                                                <label className="my-1">Total PTO Accrued</label>
                                            </p>
                                        </div>
                                    }
                                    <div className="text-center">
                                        <span className="font-weight-bold font-20 text-info">
                                            { Math.round((staffPTOInfo.used_pto + staffPTOInfo.over_ride_pto) * 100 )/100} {
                                                staffPTOInfo.is_pto_in_hours ? "hour" : "day"
                                            }{staffPTOInfo.used_pto > 1 ? "s" : ""}
                                        </span>
                                        <p className="mb-0 mt-2">
                                            <label className="my-1">Approved PTO</label>
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="font-weight-bold font-20 text-info">
                                            {staffPTOInfo.scheduled_pto} {
                                                staffPTOInfo.is_pto_in_hours ? "hour" : "day"
                                            }{staffPTOInfo.scheduled_pto > 1 ? "s" : ""}
                                        </span>
                                        <p className="mb-0 mt-2">
                                            <label className="my-1">Pending PTO</label>
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <i className="fa fa-calendar font-20 cursor-pointer"
                                            onClick={this.openPTOModal}
                                        />
                                    </div>
                                </div>{this.state.sickleaveinfoforuser["allowed_paid_sick_leave"] && this.state.is_sick_leave_allowed? 
                                <div className="d-flex justify-content-between align-items-center p-2">
                                        <div className="text-center">
                                            <span className="font-weight-bold font-20 text-info">
                                            {this.state.sickleaveinfoforuser["total_SL_earned"] } hours    
                                            </span>
                                            <p className="mb-0 mt-2">
                                                <label className="my-1">Total Sick Leave Accrued</label>
                                            </p>
                                        </div>
                                    <div className="text-center">
                                        <span className="font-weight-bold font-20 text-info">
                                            {this.state.sickleaveinfoforuser["used_sick_leave"] } hours                            
                                                      </span>
                                        <p className="mb-0 mt-2">
                                            <label className="my-1">Approved Sick Leave</label>
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="font-weight-bold font-20 text-info">
                                        0 hours
                                        </span>
                                        <p className="mb-0 mt-2">
                                            <label className="my-1">Pending Sick Leave</label>
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <i className="fa fa-calendar font-20 cursor-pointer"
                                            onClick={this.openPTOModal}
                                        />
                                    </div>
                                </div>
    : null }
                            </div>
                            : isProfileEnabled && this.renderIncomes()
                            }
                            {!score && this.renderScrollableSection()}
                        </div>
                    </div>
                    {(isProfileEnabled || !(showPTOInfo || showSharedCalendar)) ?
                        <div className="row">
                            <div className="col-md-7">
                                {score && this.renderTable()}
                            </div>
                            <div className="col-md-5 pl-md-0">
                                {score && <React.Fragment>
                                    {((isProfileEnabled && showPTOInfo) || (!isProfileEnabled && showSharedCalendar)) 
                                        && this.renderIncomes()}
                                    {this.renderScrollableSection()}
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                        : (showPTOInfo || showSharedCalendar) &&
                        this.renderScrollableSection()
                    }
                </div>
                {openClockOutModal &&
                    <ClockOutModal {...this.props} modal={openClockOutModal} 
                        toggleModal={this.toggleClockOutModal} 
                    />
                }
                {openAddAchievementModal && 
                    <AddAchievementModal {...this.props} modal={openAddAchievementModal} 
                        toggleModal={this.toggleAddAchievementModal} 
                        selectedKPI={selectedKPI} 
                        updateAchievement={this.updateAchievement} 
                        periodStartDate={periodStartDate} 
                    />
                }
                {openAchievementListModal &&
                    <StaffDataList {...this.props} modal={openAchievementListModal} 
                        toggleModal={this.toggleAchievementListModal} 
                        selectedKPI={selectedKPI} 
                        updateAchievement={this.updateAchievement} 
                        periodStartDate={periodStartDate} 
                    />
                }
                {openPTO && 
                    <PTOModal {...this.props} 
                        modal={openPTO} 
                        toggleModal={this.togglePTOModal}
                        selectedPTORequest={selectedPTORequest}
                        selectedUser={getUser().id}
                        refreshPTOInfos={this.refreshPTOInfos}
                        permission={this.auth.permission}
                    />
                }
                {this.state.isLoading && <LoadingModal modal={this.state.isLoading} />}
            </section>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/staffDashboard/Home.js